<div class="sidebar" role="dialog">
  <app-sidebar-header
    [title]="'extrasSidebar.findHotels.title.hotel' | ibeadmin | async"
  >
  </app-sidebar-header>

  <div class="block-stopover">
    <div class="grid">
      <div class="col-12 col-tp-12 col-p-12">
        <app-svg
          class="icon"
          svg="icons.svg#services--book_hotel"
          aria-hidden="true"
          [alt]="'Partner of stopover'"
        ></app-svg>
        {{ "extrasSidebar.text.hotelIn" | ibeadmin | async }} {{ city }}
      </div>
    </div>
  </div>

  <div class="sidebar__body sl--scrollable sidebar_body-wrapper" #sidebar__body>
    <div class="block-image" alt="">
      <img
        class="the-image"
        src="./assets/images/ancillaries/offers/stopover_banner.png"
        alt=""
      />
    </div>

    <hr class="separator" aria-hidden="true" />

    <div id="text_section">
      <p>
        {{ "extrasSidebar.text.takeAdvantage" | ibeadmin | async }}
      </p>
    </div>
    <br /><br /><br /><br /><br /><br />
    <hr class="separator" aria-hidden="true" />
    <div class="">
      <a
        class="link extras-feature__link"
        aria-label="Close dialog"
        (click)="INDRA_handleClose()"
        href="javascript:;"
        role="button"
      >
        {{ "extrasSidebar.text.closeThisWindow" | ibeadmin | async }}
      </a>
    </div>
    <hr class="separator" aria-hidden="true" />
  </div>
</div>
